import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  const scrollTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <p className="footer-copy">
          Copyright © {year} All rights reserved | Design by{' '}
          <span className="footer-brand">Muqeet Ahmad</span>
        </p>
        <div className="footer-links">
          <a href="https://github.com/MuqeetJanjua" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
          <a
            href="https://linkedin.com/in/muqeet-ahmad-ma/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
          <a href="mailto:muqeetahmad25@gmail.com">Email</a>
          <a href="#home" className="footer-top" onClick={scrollTop}>
            Pop to Top
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
